import React from "react";
import styles from "./navbarcom.module.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import LogoLight from "../../images/logoLight.jpeg";

function Navbarcom() {
  return (
    <Navbar bg="" expand="lg" className={styles.navbar}>
      <Container>
        <Navbar.Brand href="#home">
          {" "}
          <img src={LogoLight} className={styles.logoImg} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto reverse">
            <Nav.Link href="/#home">الرئيسية</Nav.Link>
            <Nav.Link href="/#about">من نحن</Nav.Link>
            <Nav.Link href="/#services">الخدمات</Nav.Link>

            {/* <Nav.Link href="/#work">اعمالنا</Nav.Link> */}
            <Nav.Link href="/#contact">اتصل بنا</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navbarcom;
